export default __webpack_public_path__ + "static/media/Mars-in-leo.efbb838e.jpg";